import Skeleton from "react-loading-skeleton";
import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import { styles } from "./styles";
import { withStyles } from "@material-ui/core/styles";
export const SkeletonLoader = props => {
  const {
    classes,
    className,
    count,
    width,
    height,
    duration,
    circle,
    disableAnimation
  } = props;
  return /*#__PURE__*/React.createElement("span", {
    className: classNames("prmbl-skeletonLoader", classes.root, {
      [classes.disableAnimation]: disableAnimation
    }, className)
  }, /*#__PURE__*/React.createElement(Skeleton, {
    count: count,
    width: width,
    height: height,
    duration: duration,
    circle: circle
  }));
};
SkeletonLoader.propTypes = {
  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: PropTypes.object.isRequired,
  /**
   * Classes to apply to the root
   */
  className: PropTypes.string,
  /**
   * The number of lines to show
   */
  count: PropTypes.number,
  /**
   * Width of the skeleton. Useful when the skeleton is inside an inline element with no width of its own.
   */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Height of the skeleton. Useful when you don't want to adapt the skeleton to a text element but for instance a card. Also needed for the prop circle.
   */
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Duration is how long it takes do one cycle of the skeleton animation.
   */
  duration: PropTypes.number,
  /**
   * Prop for making the skeleton look like a circle, for when you are creating a user card with a profile picture for instance.
   * Height is needed if you use this prop.
   */
  circle: PropTypes.bool,
  /**
   * Disables the animation of the prop
   */
  disableAnimation: PropTypes.bool,
  /**
   * Removes the automatic transparency and inversion of the background color in favor of a hard background color.
   */
  color: PropTypes.string
};
SkeletonLoader.defaultProps = {
  color: "rgba(0,0,0,.10)"
};
export default withStyles(styles)(SkeletonLoader);